var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "favorites-list" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("FavoritesFolderSelect", {
          model: {
            value: _vm.folder,
            callback: function ($$v) {
              _vm.folder = $$v
            },
            expression: "folder",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search" },
          [
            _c("TextBox", {
              attrs: { linear: "", placeholder: "搜索" },
              model: {
                value: _vm.search,
                callback: function ($$v) {
                  _vm.search = $$v
                },
                expression: "search",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "operation",
            attrs: { href: _vm.playLink, title: "播放全部", target: "_blank" },
          },
          [
            _c(
              "VButton",
              { staticClass: "play-all", attrs: { round: "" } },
              [_c("VIcon", { attrs: { icon: "mdi-play", size: 18 } })],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "operation",
            attrs: { href: _vm.moreLink, title: "查看更多", target: "_blank" },
          },
          [
            _c(
              "VButton",
              { staticClass: "more-info", attrs: { round: "" } },
              [
                _c("VIcon", {
                  attrs: { icon: "mdi-dots-horizontal", size: 18 },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _vm.loading && !_vm.searching
          ? _c("VLoading")
          : !_vm.loading && !_vm.canLoadMore && _vm.filteredCards.length === 0
          ? _c("VEmpty")
          : _c(
              "transition-group",
              { staticClass: "cards", attrs: { name: "cards", tag: "div" } },
              [
                _vm._l(_vm.filteredCards, function (card) {
                  return _c(
                    "div",
                    { key: card.id, staticClass: "favorite-card" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "favorites-cover-container",
                          attrs: {
                            target: "_blank",
                            href: _vm.getItemPlayLink(card),
                          },
                        },
                        [
                          _c("DpiImage", {
                            staticClass: "cover",
                            attrs: {
                              src: card.coverUrl,
                              size: { width: 130, height: 85 },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "floating duration" }, [
                            _vm._v(_vm._s(card.durationText)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "floating favorite-time" }, [
                            _vm._v(_vm._s(card.favoriteTime)),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "title",
                          attrs: {
                            target: "_blank",
                            href: _vm.getItemPlayLink(card),
                            title: card.title,
                          },
                        },
                        [_vm._v(_vm._s(card.title))]
                      ),
                      _vm._v(" "),
                      card.upID
                        ? _c(
                            "a",
                            {
                              staticClass: "up",
                              attrs: {
                                target: "_blank",
                                href: "https://space.bilibili.com/" + card.upID,
                                title: card.upName,
                              },
                            },
                            [
                              _c("DpiImage", {
                                staticClass: "face",
                                attrs: {
                                  "placeholder-image": "",
                                  src: card.upFaceUrl,
                                  size: 20,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "name" }, [
                                _vm._v(_vm._s(card.upName)),
                              ]),
                            ],
                            1
                          )
                        : _c("div", { staticClass: "description" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(card.description) +
                                "\n        "
                            ),
                          ]),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.canLoadMore
                  ? _c("ScrollTrigger", {
                      key: "scroll-trigger",
                      on: {
                        trigger: function ($event) {
                          return _vm.scrollTrigger()
                        },
                      },
                    })
                  : _vm._e(),
              ],
              2
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }